import React, { useEffect, useState } from "react"
import styles from "./zaiaIntegration.module.css"
import moment from "moment"
import { toast } from "react-toastify"
import Button from "../../components/Form/Button"
import Table from "../../components/Table"
import Loading from "../layouts/Loading"
import api from "../../services/api"
import ModalAgent from "../../components/Modal/Zaia/ModalAgent"
import { getOptionByOptionList } from "../../utils/utils"
import BackButton from "../../components/BackButton"
import { useParams } from "react-router-dom"

const headers = [
    "#",
    "Nome",
    "ID do Agente",
    "Status",
    "Última Modificação",
    "",
]

const status = [
    { id: "DRAFT", value: "Rascunho" },
    { id: "ACTIVE", value: "Ativo" },
]

const ZaiaIntegration = () => {
    const [data, setData] = useState([])
    const [agentEdit, setAgentEdit] = useState({})
    const [showModalNewAgent, setShowModalNewAgent] = useState(false)
    const [loading, setLoading] = useState(false)
    const { account_id } = useParams()

    useEffect(() => {
        getAllAgents()
    }, [])

    const getAllAgents = () => {
        setLoading(true)
        api.get(`/integrations/zaia/agents`).then(response => {
            const agents = response.data.data || []
            setData(agents)
        }).catch(err => console.log(err)).finally(() => setLoading(false))
    }

    const getDataByAgent = (agent) => {
        return {
            id: agent._id,
            value: [
                agent.name,
                agent.agent_id,
                getOptionByOptionList(agent.status, status),
                moment(agent.updated_at).format("DD/MM/YYYY HH:mm:ss"),
            ],
            actions: [
                {
                    label: "Editar",
                    onClick: handleGetAgentDataAndOpenModal
                }
            ]
        }
    }

    const handleGetAgentDataAndOpenModal = (id) => {
        const agent = data.find(agent => agent._id === id)
        if (agent) {
            handleOpenModalAgent(agent)
        }
    }

    const handleOpenModalAgent = (agent) => {
        setShowModalNewAgent(true)
        setAgentEdit(agent)
    }

    const handleCloseModalAgent = () => {
        setShowModalNewAgent(false)
        setAgentEdit({})
    }

    const handleSaveAgent = (agent, isNew = true) => {
        setLoading(true)
        const url = `/integrations/zaia/agents`
        if (isNew) {
            api.post(url, agent).then(response => {
                const newAgent = response.data.data || {}
                if (newAgent) {
                    setData(previousValue => ([...previousValue, newAgent]))
                }
                handleCloseModalAgent()
            }).catch(err => toast.error(err?.response?.data?.message)).finally(() => setLoading(false))
        } else {
            api.patch(url, agent).then(response => {
                const newAgent = response.data.data || {}
                if (newAgent) {
                    setData(previousValue => (
                        previousValue.map(agent => {
                            if (agent._id === newAgent._id) {
                                return newAgent
                            }
                            return agent
                        })
                    ))
                }
                handleCloseModalAgent()
            }).catch(err => toast.error(err?.response?.data?.message)).finally(() => setLoading(false))
        }
    }

    return (
        <div className={styles.container}>
            <div className="page-back-row">
                <BackButton fallback={`/${account_id}/integrations/chat`} />
            </div>
            <div className={styles.actions}>
                <Button variant="primary" onClick={() => handleOpenModalAgent()}>Adicionar Agente</Button>
            </div>
            <Table
                headers={headers}
                values={data.map(getDataByAgent)}
                onClick={handleGetAgentDataAndOpenModal}
                messageNotRegisters="Nenhum registro encontrado"
                showIndex={true}
            />
            {showModalNewAgent &&
                <ModalAgent
                    data={agentEdit}
                    optionsStatus={status}
                    onSubmit={handleSaveAgent}
                    closeModal={handleCloseModalAgent}
                />
            }
            {loading && <Loading fullPage={true} />}
        </div>
    )
}

export default ZaiaIntegration
